// extracted by mini-css-extract-plugin
export var videoContainer = "Video-module--videoContainer--xa0MP";
export var splashScreen = "Video-module--splashScreen--2ioSb";
export var cover = "Video-module--cover--hc5pa";
export var ytbtn = "Video-module--ytbtn--FzY6n";
export var modalContainer = "Video-module--modalContainer--O0YoZ";